import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.process;

export default class Process extends Model {
  static entity = `${name}`;

  static fields() {
    return {
      id: this.increment(1),
      name: this.string(''),
      unique_id: this.string(''),
      stages: this.attr([]),
    };
  }
}
